import CkEditorContainer from "../../../../Components/Miscellaneous/Editors/CkEditor/CkEditorContainer";

const CkEditors = () => {
  return <CkEditorContainer />;
};

export default CkEditors;
